import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import PageLoader from "../../componenets/PageLoader";
import '../../style/style.css';
import { getBrandsDetail, updateBrandsDetail, addBrands } from "../../services/data/brands";
import "bootstrap/dist/css/bootstrap.min.css";

const groupSchema = Yup.object().shape({
  name: Yup.string().required("Please enter the name"),   
});

function AddGroupModal({ show, handleClose, id, fetchUsers, detail }) {  
  // console.log(detail, 'akkkkkk')
  const [loading, setLoading] = useState(false)
   
  const [initialValues, setInitialValues] = useState({
    name:"",       
  });
 
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    handleReset,
    // setFieldValue,
    errors,
    touched,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: groupSchema,
    enableReinitialize:true,
    onSubmit: async (values) => {      
      setLoading(true)
      if(id){
        await updateBrandsDetail(id,values).then((response)=>{
          if (response.data.status === "error"){
            toast.error(response.data.message);            
          }
          else if (response.status === 200 || response.data.status === 'success'){
            toast.success(response.data.message)
            fetchUsers()
            handleClose()            
          }
          else {
            toast.error(response.data.message)           
          }
        })
        .catch((err)=>{
          toast.error("Some error occured update")         
        })
        .finally(()=>{
          setLoading(false)
        })
      }
      else{
        await addBrands(values).then((response) => {
          if (response.status === 201 || response.data.status === 'success'){
            toast.success(response.data.message)
            fetchUsers()
            handleClose()            
          }
          else{
            toast.error(response.data.message)            
          }
        })
        .catch((err)=>{
          toast.error("Some error Occured add")          
        })
        .finally(()=>{
          setLoading(false)
        })
      }
    },
  });

  useEffect(() => {   
    if(id && detail){
      async function fetchData(){       
        setInitialValues(              
          {
            name:detail.name,                               
          }
        )
      }
      fetchData()
    }    
  }, [id]);

  return (
    <Modal 
     show={show} 
     onHide={handleClose} 
     size="md"
     centered         
    >
      { loading ? <PageLoader loading="Loading..."/> :(
        <form 
         onSubmit={handleSubmit}
         className="justify-content-center"
        >
          <Modal.Header 
            closeButton 
            style={{
              backgroundColor:"#dcedc8"
            }}              
          >          
            <>
              <Modal.Title><b>{id ? 'Edit Group' : 'Add Group'}</b></Modal.Title>
            </>       
          </Modal.Header>
          <Modal.Body 
            style={{
              backgroundColor:'#f4faed'
            }}
          >
            <div className="container-fluid"  
              style={{
                backgroundColor:'#f4faed'
              }} 
            >
              <div className="row">
                <div className='col-12'>
                  <div className="form-group">
                    <label htmlFor="name">
                      Name
                    </label>
                    <div class="input-group">
                      <input
                        className="form-control"
                        id="name"
                        type="text"
                        placeholder="Enter the group name"
                        name="name"
                        value={values.name}
                        onBlur={handleBlur}
                        onChange={handleChange}                        
                      />
                    </div>
                    {errors.name && touched.name && (
                      <b className="text-danger">
                        {errors.name}
                      </b>
                    )}
                  </div>
                </div>                                                                
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer 
            className="d-flex flex-row justify-content-center"
            style={{
              backgroundColor:'#f4faed'
            }}
          >          
            <button
              type="reset"
              className="btn btn-warning"
              onClick={handleReset}
            >
              Reset
            </button>
            <button
              type="submit"
              className="btn btn-primary"              
            >
              Submit
            </button> 
            <button
              type="button"
              className="btn btn-danger" 
              onClick ={()=>{handleClose()}}
            >
              Cancel
            </button>          
          </Modal.Footer>   
        </form> 
      )} 
    </Modal>
  );
}

export default AddGroupModal

